import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ProfileRedirectProps {
  username: string;
}

export const ProfileRedirect = ({ username }: ProfileRedirectProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect all old profile links to creators page
    // ProfileDrawer handles viewing profiles now
    navigate('/creators', { replace: true });
  }, [navigate]);

  return null;
};
